import { addNavMenuSection } from '@vendure/admin-ui/core';
import { Permission } from './generated-types';

export default [
  addNavMenuSection({
    id: 'blog',
    label: 'Blog',
    requiresPermission: Permission.ReadBlog,
    items: [
      {
        id: 'blog-posts',
        label: 'Posts',
        routerLink: ['/extensions/blog/posts'],
        icon: 'file-group',
        requiresPermission: Permission.ReadBlog
      },
      {
        id: 'blog-categories',
        label: 'Categories',
        routerLink: ['/extensions/blog/categories'],
        icon: 'folder',
        requiresPermission: Permission.ReadBlog
      },
      {
        id: 'blog-tags',
        label: 'Tags',
        routerLink: ['/extensions/blog/tags'],
        icon: 'tag',
        requiresPermission: Permission.ReadBlog
      }
    ]
  })
];
